<ndt-call-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [callCostPrivileges]="callCostPrivileges$ | async"
   [columns]="columns"
   [pluralNameOverride]="pluralName"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (create)="onAddProviderFile()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
>
</ndt-call-register-view>
